const API_CONFIG = {
  BASE_URL: "/business/proxy/comphub-product"
};

export default API_CONFIG;

